import React from 'react';
import PropTypes from 'prop-types';
import {getText} from 'helpers/text-helper';
import {progressData} from 'data/progress-data';
import './game-progress.scss';

const GameProgress = ({languageId, deviceInfo, progressStepId}) => {
	return (
		<div className={'GameProgress ' + deviceInfo.orientation}>
			{progressData.map((progressStep) => {
				return (
					<div 
						key={progressStep.id} 
						className={'GameProgress-step' + (progressStepId === progressStep.id ? ' current' : '')}
					>
						<div className="GameProgress-stepCircle" />
						<div className="GameProgress-stepTitle">
							<span>{getText(progressStep.text, languageId)}</span>
						</div>
					</div>
				);
			})}			
		</div>
	);
};

GameProgress.propTypes = {
	languageId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	progressStepId: PropTypes.string.isRequired,
};

export default GameProgress;